import axios from '../utils/axios';

export const getUser = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/${userId}`);

export const viewUser = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/${userId}`);

export const editUser = async (userId, userData, token) =>
  await axios.put(`${process.env.REACT_APP_API}/user/update/${userId}`, userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const viewUser2 = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user2/${userId}`);

export const followUser = async (userId) =>
  await axios.put(`${process.env.REACT_APP_API}/follow/${userId}`);

export const unfollowUser = async (userId) =>
  await axios.put(`${process.env.REACT_APP_API}/unfollow/${userId}`);

export const updatePassword = async (userId, password) =>
  await axios.put(`${process.env.REACT_APP_API}/user/password/${userId}`, password);

export const getUserProducts = async (userId) =>
  await axios.post(`${process.env.REACT_APP_API}/user/products/${userId}`, {});

export const userActiveProducts = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/active-products/${userId}`);

export const userPendingProducts = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/pending-products/${userId}`);

export const userClosedProducts = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/closed-products/${userId}`);

export const userFavouriteProducts = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/favourite-products/${userId}`);

export const getUserNotifications = async (userId) =>
  await axios.get(`${process.env.REACT_APP_API}/user/notifications/${userId}`);

export const markNotificationsRead = async () =>
  await axios.post(`${process.env.REACT_APP_API}/user/read-notifications`);

export const setMsgToUnread = async (messageId) =>
  await axios.post(`${process.env.REACT_APP_API}/user/unread-message`, { messageId });

export const markMessageRead = async (messageId) =>
  await axios.post(`${process.env.REACT_APP_API}/user/read-message`, { messageId });